export const QMDI_NAMESPACE = 'qmdi.' as const;
export const CANCEL_MESSAGE = 'cancel request'
export const DEFAULT_LOCALE = localStorage.getItem(`${QMDI_NAMESPACE}locale`) || 'en-GB';
